module.exports = __webpack_public_path__ + "static/media/uoc_logo.9f78574a.svg";